import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable, shareReplay} from 'rxjs';
import {ApiInfo} from '../../models/apiinfo';
import {environment} from '../../env';
import { AppLogger, AppLoggerService } from '../../core/logging';

@Injectable({
  providedIn: 'root'
})
export class ApiinfoService {

  private readonly log: AppLogger;
  private apiInfo$?: Observable<ApiInfo>;

  constructor(private http: HttpClient, appLogger: AppLoggerService) {
    this.log = appLogger.createForClass(ApiinfoService);
  }

  getApiInfo(): Observable<ApiInfo> {
    if (!this.apiInfo$) {
      this.apiInfo$ = this.http.get<ApiInfo>(`${environment.apiUrl}/info`).pipe(
        shareReplay({ bufferSize: 1, refCount: true })
      );
    }
    return this.apiInfo$;
  }

}
